// contexts/NotificationContext/useLpClickSound.ts
// Suara notifikasi saat pengunjung klik CTA di Landing Page.
// SEMUA user yang login dengar 1 beep (1 baris `lp_click_events` = 1 beep),
// suara saja — tanpa toast/browser notification (permintaan 2026-10-24).
import { useEffect, useRef } from 'react';
import { createResilientSubscription } from '../../utils/realtimeManager';
import { playLpClickSound, primeAudio } from '../../utils/audioPlayer';

// "1x aja": klik beruntun cepat tetap 1 beep.
const CLICK_COOLDOWN_MS = 2000;

export function useLpClickSound(userId?: string) {
  const lastBeepRef = useRef(0);

  useEffect(() => {
    if (!userId) return;

    // Kebijakan autoplay: AudioContext baru boleh bunyi setelah interaksi.
    // Listener PERMANEN (bukan once) — tiap gesture coba resume supaya
    // unlock tetap berlaku walau tab dibuka lama/background.
    const prime = () => { void primeAudio(); };
    window.addEventListener('pointerdown', prime);
    window.addEventListener('keydown', prime);

    const sub = createResilientSubscription({
      channelName: `lp-click-sound-${userId}`,
      event: 'INSERT',
      table: 'lp_click_events',
      callback: () => {
        const now = Date.now();
        if (now - lastBeepRef.current < CLICK_COOLDOWN_MS) return;
        lastBeepRef.current = now;
        void playLpClickSound();
      },
    });

    return () => {
      sub.unsubscribe();
      window.removeEventListener('pointerdown', prime);
      window.removeEventListener('keydown', prime);
    };
  }, [userId]);
}
